import { DashboardOutlined, MailOutlined } from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "Usermanage",
    title: "User Manage",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "user-List",
        path: `${APP_PREFIX_PATH}/users`,
        title: "User List",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "Master Data",
    path: `${APP_PREFIX_PATH}/master`,
    title: "Master Data",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "Branch-List",
        path: `${APP_PREFIX_PATH}/branches`,
        title: "Branch List",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "CSC-List",
        path: `${APP_PREFIX_PATH}/cscs`,
        title: "CSC List",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "E Application",
    path: `${APP_PREFIX_PATH}/application`,
    title: "E Application",
    icon: DashboardOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "App-List",
        path: `${APP_PREFIX_PATH}/applications`,
        title: "Application List",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "schedules-list",
        path: `${APP_PREFIX_PATH}/schedules`,
        title: "Schedules",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "Complains",
    path: `${APP_PREFIX_PATH}/complains`,
    title: "Complains",
    icon: DashboardOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "Complain-List",
        path: `${APP_PREFIX_PATH}/complains`,
        title: "List",
        icon: MailOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  // {
  //   key: "Locked",
  //   path: `${APP_PREFIX_PATH}/locked`,
  //   title: "Locked Accounts",
  //   icon: DashboardOutlined,
  //   breadcrumb: true,
  //   submenu: [
  //     {
  //       key: "Locked-List",
  //       path: `${APP_PREFIX_PATH}/locked`,
  //       title: "List",
  //       icon: MailOutlined,
  //       breadcrumb: true,
  //       submenu: [],
  //     },
  //   ],
  // },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
